import { NavigationMenu } from '@justomx/atlas-design-system'
import { UserManagment } from '@justomx/webview-commons'
import { useGoToHomePage } from '../home/home-list/HomeList.navigator'

export const MenuPage = () => {
  console.info('[rendering] MenuPage')
  const home = useGoToHomePage()
  const user = UserManagment.getCurrentUser()
  return (
    <NavigationMenu
      text="Menu"
      version="13.0.1"
      country={user.country}
      userEmail={user?.username || 'justicierx@justo.mx'}
      userName={user?.firstName || 'Justicierx'}
      warehouseName={user.warehouse || 'Pruebas'}
      menuItems={user.menuItems || []}
      isMenuOpen
      onLogout={() => {
        UserManagment.logout()
        home.go()
      }}
    />
  )
}
